import { AllocationRule } from 'further-types/lp/allocations';
import Table, { Column as TableColumn } from 'further-ui/components/Table';
import { Column } from 'further-ui/components/Layout';
import RadioButtons from 'further-ui/components/RadioButtons';

export type EqualisationsAllocationsTableProps<T extends { id: string }> = {
  columns: Array<TableColumn<T>>;
  rows: Array<T>;
  showAllocationRule?: boolean;
  allocationRule?: AllocationRule;
  allocationRuleOptions?: Array<{ value: AllocationRule; label: string }>;
  onChangeAllocationRule?: (value: AllocationRule) => void;
  isNotEditable?: boolean;
  checkboxes?: {
    isCheckedRow: (row: T, rowIndex: number) => boolean;
    isDisabledRow?: (row: T, rowIndex: number) => boolean;
    onRowCheckedToggle: (row: T, rowIndex: number) => void;
  };
};

const EqualisationsAllocationsTable = <T extends { id: string }>({
  columns,
  rows,
  checkboxes,
  showAllocationRule = true,
  allocationRule,
  allocationRuleOptions = [],
  onChangeAllocationRule,
  isNotEditable = false,
}: EqualisationsAllocationsTableProps<T>) => {
  return (
    <Column spacing="sm">
      {showAllocationRule && (
        <RadioButtons
          value={allocationRule ?? null}
          disabled={isNotEditable}
          options={allocationRuleOptions}
          onChange={(value) => {
            const selectedOption = allocationRuleOptions.find(
              (option) => option.value === value,
            );
            if (selectedOption) {
              onChangeAllocationRule?.(selectedOption.value);
            }
          }}
          direction="row"
        />
      )}
      <Table
        checkboxes={checkboxes}
        showTopBorder
        scrollable
        showHeaderBorder
        rows={rows}
        columns={columns}
      />
    </Column>
  );
};

export default EqualisationsAllocationsTable;
